import React, {useState, useEffect} from 'react';

import Select, {components} from 'react-select';

import GuiSelectorItem from './GuiSelectorItem';

import {ReactComponent as DropdownIcon} from "../../assets/flyerDetailsPopupAssets/dropdown.svg";

import './GuiSelector.scss';
import {GuiSettingsDto} from '../../dtos';

interface IGuiSelector {
    onChange?: (guiSetting: GuiSettingsDto) => void;
    selectedItem: GuiSettingsDto;
    items: GuiSettingsDto[];
    isNew?: boolean
}

const GuiSelector: React.FC<IGuiSelector> = (props) => {

    /*
    const fonts = [
        { value: Globals.FONT_NAME_ARIAL },
        { value: Globals.FONT_NAME_ROBOTO }
    ];

    const fontSizes = [
        { value: Globals.FONT_SIZE_1 },
        { value: Globals.FONT_SIZE_2 },
        { value: Globals.FONT_SIZE_3 }
    ];*/
    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            height: '58px',
            minHeight: 'auto',
            border: '1px solid #888888',
            fontWeight: 'normal',
            textAlign: 'start',
            cursor: 'pointer',
            padding: '0',
            ':hover': {
                borderColor: "#888888"
            }

            // You can also use state.isFocused to conditionally style based on the focus state
        }),
        valueContainer: (base: any) => ({
            ...base,
            padding: '0px'
        }),

        menuList: (base: any) => ({
            ...base,
            height: "264px",
            fontWeight: 'normal'
        }),
        menu: (base: any) => ({
            ...base,
            zIndex: `2`,
        })

    };


    // const theme = (theme: any) => ({
    //     ...theme,
    //     colors: {
    //         ...theme.colors,
    //         //   primary25: "#D1D7DB",
    //         primary: "#D1D7DB",
    //
    //         // All possible overrides
    //         // primary: '#2684FF',
    //         // primary75: '#4C9AFF',
    //         // primary50: '#B2D4FF',
    //         // primary25: '#DEEBFF',
    //
    //         // danger: '#DE350B',
    //         // dangerLight: '#FFBDAD',
    //
    //         // neutral0: 'hsl(0, 0%, 100%)',
    //         // neutral5: 'hsl(0, 0%, 95%)',
    //         // neutral10: 'hsl(0, 0%, 90%)',
    //         // neutral20: 'hsl(0, 0%, 80%)',
    //         // neutral30: 'hsl(0, 0%, 70%)',
    //         // neutral40: 'hsl(0, 0%, 60%)',
    //         // neutral50: 'hsl(0, 0%, 50%)',
    //         // neutral60: 'hsl(0, 0%, 40%)',
    //         // neutral70: 'hsl(0, 0%, 30%)',
    //         // neutral80: 'hsl(0, 0%, 20%)',
    //         // neutral90: 'hsl(0, 0%, 10%)',
    //     }
    //     // Other options you can use
    //     // borderRadius: 4
    //     // baseUnit: 4,
    //     // controlHeight: 38
    //     // menuGutter: baseUnit * 2
    // });


    //const [font, setFont] = useState(props.fontName ? props.fontName : fonts[0]);
    //const [fontSize, setFontSize] = useState(props.fontSize ? props.fontSize : fontSizes[0]);

    const [item, setItem] = useState<GuiSettingsDto>(props.selectedItem);

    const onFontChange = (item: any) => {
        setItem(item);


        if (props.onChange) {
            props.onChange!(item);
        }
    };

    useEffect(() => {
        setItem(props.selectedItem);

    }, [props.selectedItem])


    const CustomOption = (props: any) => {
        const {data, innerRef, innerProps} = props;
        return (
            <components.Option {...props} >
                <GuiSelectorItem {...props} guiSettings={data}/>
            </components.Option>
        )
    };
    const DropdownIndicator = (props: any) => {
        return (
            <components.DropdownIndicator {...props}>
                <DropdownIcon/>
            </components.DropdownIndicator>
        );
    };


    return (
        <div className={props.isNew ? "" : 'font_selector_container row'}>
            <div className={props.isNew ? '' : 'col-sm-12'}>

                <div className="gui_selector_item_container">
                    <GuiSelectorItem guiSettings={item}/>
                </div>

                <Select
                    styles={customStyles}
                    isSearchable={false}
                    classNamePrefix='font_selector'
                    value={item}
                    onChange={onFontChange}
                    getOptionValue={(option) => option.gusCaption!}
                    getOptionLabel={(option) => option.gusCaption!}
                    options={props.items}
                    // theme={theme}
                    components={{
                        Option: CustomOption,
                        DropdownIndicator
                    }}
                />


            </div>

        </div>
    )
}

export default GuiSelector;